import button from './components/button';
import headerImage from './components/headerImage';
import footer from './components/footer';
import style from './components/style';
import tinycolor from 'tinycolor2';

module.exports = {
  text: 'Congratulations to This Month\'s Winner',
  value: 'congratulations',
  usersContext: 'LEADERBOARDS',
  subject: 'Congratulations to this month’s winner',
  mjml(params) {
    const { brandingSettings: branding } = params;
    const slots = params.slots.map(({ content }) => ({
      content: content
        .replace(/{{[\s]*company\.name[\s]*}}/g, '{{defaults company.branding.name company.name "Referrals"}}'),
    }));

    return `<mjml>
      <mj-head>
        <mj-title>${params.subject}</mj-title>
        <mj-include path="../include/styles.mjml"/>
        <mj-attributes>
          <mj-class name="content" background-color="${branding.backgroundColour || '#ffffff'}" border-radius="4px"/>
        </mj-attributes>
        <mj-style>
          ${style(branding)}
        </mj-style>
      </mj-head>

      <mj-body
        width="760px"
        background-color="${branding.backgroundColour || '#ffffff'}"
      >

        ${!branding.hideBrandLogo ? `<mj-section>
          <mj-column>
            <mj-include path="../include/branding-logo.mjml"/>
          </mj-column>
        </mj-section> ` : ''}

        ${branding.headerImage ? headerImage(branding.headerImage) : ''}

        <mj-section>
          <mj-column width="100%">
            <mj-text
              font-size="24px" color="${branding.secondaryColour || '#333333'}"
              font-family="${branding.headerFont || 'Arial'}"
            >
              <b>${slots[1].content}</b>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section padding="0px 16px">
          <mj-column padding-bottom="20px" width="30%">
            <mj-image width="150px" src="${slots[2].content}" />
          </mj-column>
          <mj-column padding-bottom="20px" width="70%">
            <mj-text color="${branding.secondaryColour || '#333333'}">
              <div class="text-content">${slots[3].content}</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section
          padding="44px 16px"
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
        >
          <mj-column padding-bottom="20px" width="100%">
            <mj-text
              font-size="26px"
              line-height="36px"
              align="center"
              font-family="${branding.headerFont || 'Arial'}"
              color="${branding.secondaryColour || '#333333'}"
            >
              <b>${slots[4].content}</b>
            </mj-text>
          </mj-column>
          <mj-column width="100%">
            ${button('Login Now', branding)}
          </mj-column>
        </mj-section>

        ${footer(branding)}

        <mj-include path="../include/footer-disclaimer.mjml"/>
      </mj-body>
    </mjml>`;
  },
  slots: [
    {
      name: 'Title',
      type: 'input',
      defaultContent: 'Congratulations to this month\'s real links winner!',
    },
    {
      name: 'Winner\'s name',
      type: 'input',
      defaultContent: 'It\'s [Jimbo Patel]!',
    },
    {
      name: 'Winner\'s picture',
      type: 'input',
      defaultContent: 'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    },
    {
      name: 'Winner\'s introduction',
      type: 'html',
      defaultContent: `
        <p>[Jimbo] has been busy this month. Gaining points and coming out top on the leadboard. Winning [£250 to
        spend at Amazon].</p>
        <p>Well done [Jimbo], you absolute legend.</p>
      `,
    },
    {
      name: 'Footer text',
      type: 'input',
      defaultContent: 'Don\'t get left behind. Login now and start winning points (they really do mean prizes).',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/emails/congratulations.js